import { useEffect, useState } from "react";
import DynamicForm from "../components/forms/DynamicForm";
import { postJson } from "../util/apiUtils";

export default function PersonalIntakePage() {
    const [jsonSchema, setJsonSchema] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState(null);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    useEffect(() => {
        fetch("/forms/intake.json")
            .then(res => {
                if (!res.ok) {
                    throw new Error("Failed to load schema");
                }
                return res.json();
            })
            .then(data => {
                const lastYear = new Date().getFullYear() - 1;
                const processedSchema = JSON.parse(
                    JSON.stringify(data).replaceAll("{lastYear}", lastYear)
                );
                setJsonSchema(processedSchema);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <p>Loading form...</p>;
    if (error) return <p>Error: {error}</p>;

    const onSubmit = async (answers, captchaToken) => {
        if (submitting) return;

        setSubmitting(true);
        setSubmitMessage(null);

        try {

            const payload = {
                formType: "intake.json",
                submittedAt: new Date().toISOString(),
                answers
            };

            await postJson("/intake", payload,
                {
                    "X-Captcha-Token": captchaToken
                });

            setSubmitSuccess(true);
            setSubmitMessage("Form submitted successfully.");
            localStorage.removeItem("personalIntakeForm");

        } catch (err) {

            setSubmitSuccess(false);
            setSubmitMessage("Submission failed. Please try again.");

            console.error(err);

        } finally {
            setSubmitting(false);
        }
    };


    return <>
        <section id="intake" className="m-5 p-5 bg-white rounded-xl shadow-lg">
            <h2 className="text-3xl font-bold mb-4 text-gray-800">Personal Intake Form</h2>

            {!submitSuccess && (
                <DynamicForm jsonSchema={jsonSchema}
                             storage="personalIntakeForm"
                             onSubmit={onSubmit}
                             submitting={submitting}
                />
            )}

            {submitMessage && (
                <div
                    className={`mt-4 p-3 rounded-lg text-sm font-medium ${
                        submitSuccess
                            ? "bg-green-100 text-green-800 border border-green-300"
                            : "bg-red-100 text-red-800 border border-red-300"
                    }`}
                >
                    {submitMessage}
                </div>
            )}

        </section>
    </>;
}